import { createSlice } from "@reduxjs/toolkit";
import {
  verifyRegisterEmail,
  verifyEmailOTP,
} from "../../reduxThunk/thunkForgetPassword/Forget";

const initialState = {
  forgetData: [],
  loading: false,
  error: null,
  success: false,
};

const forgetSlice = createSlice({
  name: "forget",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(verifyRegisterEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(verifyRegisterEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.forgetData = action.payload;
        state.success = true;
      })
      .addCase(verifyRegisterEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "failed to login user";
        state.success = false;
      })
      .addCase(verifyEmailOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(verifyEmailOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.forgetData = action.payload;
        state.success = true;
      })
      .addCase(verifyEmailOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "failed to login user";
        state.success = false;
      });
  },
});

export default forgetSlice.reducer;
